import s from './index.module.css';

const size = 48;

export const Loader = () => (
    <div className={s.container} style={{ width: size, height: size }}>
        <svg className={s.loader} viewBox='0 0 48 48'>
            <circle r='22' cy='24' cx='24' className={s.circle} />
        </svg>
    </div>
);
